/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetExcelConfigHeaderDto
 */
export interface GetExcelConfigHeaderDto {
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigHeaderDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigHeaderDto
     */
    pokColumnName: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigHeaderDto
     */
    pokColumnNamePl: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigHeaderDto
     */
    pokColumnNameEn: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigHeaderDto
     */
    excelColumnName: string;
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigHeaderDto
     */
    excelConfigId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetExcelConfigHeaderDto
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetExcelConfigHeaderDto
     */
    order?: number;
}

/**
 * Check if a given object implements the GetExcelConfigHeaderDto interface.
 */
export function instanceOfGetExcelConfigHeaderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "pokColumnName" in value;
    isInstance = isInstance && "pokColumnNamePl" in value;
    isInstance = isInstance && "pokColumnNameEn" in value;
    isInstance = isInstance && "excelColumnName" in value;
    isInstance = isInstance && "excelConfigId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetExcelConfigHeaderDtoFromJSON(json: any): GetExcelConfigHeaderDto {
    return GetExcelConfigHeaderDtoFromJSONTyped(json, false);
}

export function GetExcelConfigHeaderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExcelConfigHeaderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pokColumnName': json['pokColumnName'],
        'pokColumnNamePl': json['pokColumnNamePl'],
        'pokColumnNameEn': json['pokColumnNameEn'],
        'excelColumnName': json['excelColumnName'],
        'excelConfigId': json['excelConfigId'],
        'active': json['active'],
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}

export function GetExcelConfigHeaderDtoToJSON(value?: GetExcelConfigHeaderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'pokColumnName': value.pokColumnName,
        'pokColumnNamePl': value.pokColumnNamePl,
        'pokColumnNameEn': value.pokColumnNameEn,
        'excelColumnName': value.excelColumnName,
        'excelConfigId': value.excelConfigId,
        'active': value.active,
        'order': value.order,
    };
}

